import React, { memo } from 'react'
import PropTypes from 'prop-types'
import {
  EmailShareButton,
  EmailIcon,
  FacebookShareButton,
  FacebookIcon,
  InstapaperShareButton,
  InstapaperIcon,
  LineShareButton,
  LineIcon,
  LinkedinShareButton,
  LinkedinIcon,
  LivejournalShareButton,
  LivejournalIcon,
  MailruShareButton,
  MailruIcon,
  OKShareButton,
  OKIcon,
  PinterestShareButton,
  PinterestIcon,
  PocketShareButton,
  PocketIcon,
  RedditShareButton,
  RedditIcon,
  TelegramShareButton,
  TelegramIcon,
  TumblrShareButton,
  TumblrIcon,
  TwitterShareButton,
  ViberShareButton,
  ViberIcon,
  VKShareButton,
  VKIcon,
  WhatsappShareButton,
  WhatsappIcon,
  WorkplaceShareButton,
  WorkplaceIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  WeiboShareButton,
  WeiboIcon
} from 'react-share'

// X icon was introduced in react-share v5.0.0, but we need to use the old version for now
const XIcon = ({ size = 32, className = '' }) => (
  <svg id="x-icon" viewBox="0 0 64 64" width={size} height={size} className={className + ' social__links'}>
    <circle cx={size} cy={size} r={size} fill="#000"/>
    <g transform="translate(13, 13) scale(1.6)">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" fill="#fff"/>
    </g>
  </svg>
)

XIcon.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

XIcon.defaultProps = {
  size: 32,
  className: ''
}

const SocialLinks = ({
  // link options
  email,
  facebook,
  instapaper,
  line,
  linkedin,
  livejournal,
  mailru,
  messenger,
  ok,
  pinterest,
  pocket,
  reddit,
  telegram,
  tumblr,
  twitter,
  viber,
  vk,
  weibo,
  whatsapp,
  workplace,
  // other params
  facebookAppId,
  url,
  imageUrl,
  onClick,
  title,
  className,
  description
}) => {
  const clickHandler = (type) => Promise.resolve(onClick(type))
  return url
    ? ([
        email
          ? (
      <EmailShareButton key='socialEmail' url={url} beforeOnClick={() => clickHandler('email')} className='share__button--email'>
        <EmailIcon size={32} round className={className} subject={title} />
      </EmailShareButton>
            )
          : null,
        facebook
          ? (
      <FacebookShareButton key='socialFacebook' url={url} beforeOnClick={() => clickHandler('facebook')} className='share__button--facebook'>
        <FacebookIcon size={32} round className={className} />
      </FacebookShareButton>
            )
          : null,
        instapaper
          ? (
      <InstapaperShareButton key='socialInstapaper' url={url} beforeOnClick={() => clickHandler('instapaper')} title={title} description={description} className='share__button--instapaper'>
        <InstapaperIcon size={32} round className={className} />
      </InstapaperShareButton>
            )
          : null,
        line
          ? (
      <LineShareButton key='socialLine' url={url} beforeOnClick={() => clickHandler('line')} title={title} className='share__button--line'>
        <LineIcon size={32} round className={className} />
      </LineShareButton>
            )
          : null,
        linkedin
          ? (
      <LinkedinShareButton key='socialLinkedin' url={url} beforeOnClick={() => clickHandler('linkedin')} title={title} summary={description} className='share__button--linkedin'>
        <LinkedinIcon size={32} round className={className} />
      </LinkedinShareButton>
            )
          : null,
        livejournal
          ? (
      <LivejournalShareButton key='socialLivejournal' url={url} beforeOnClick={() => clickHandler('livejournal')} title={title} description={description} className='share__button--livejournal'>
        <LivejournalIcon size={32} round className={className} />
      </LivejournalShareButton>
            )
          : null,
        mailru
          ? (
      <MailruShareButton key='socialMailru' url={url} beforeOnClick={() => clickHandler('mailru')} title={title} description={description} imageUrl={imageUrl} className='share__button--mailru'>
        <MailruIcon size={32} round className={className} />
      </MailruShareButton>
            )
          : null,
        ok
          ? (
      <OKShareButton key='socialOK' url={url} beforeOnClick={() => clickHandler('ok')} title={title} description={description} imageUrl={imageUrl} className='share__button--ok'>
        <OKIcon size={32} round className={className} />
      </OKShareButton>
            )
          : null,
        pinterest && imageUrl
          ? (
      <PinterestShareButton key='socialPinterest' media={imageUrl} url={url} beforeOnClick={() => clickHandler('pinterest')} description={title} className='share__button--pinterest'>
        <PinterestIcon size={32} round className={className} />
      </PinterestShareButton>
            )
          : null,
        pocket
          ? (
      <PocketShareButton key='socialPocket' url={url} beforeOnClick={() => clickHandler('pocket')} title={title} className='share__button--pocket'>
        <PocketIcon size={32} round className={className} />
      </PocketShareButton>
            )
          : null,
        reddit
          ? (
      <RedditShareButton key='socialReddit' url={url} beforeOnClick={() => clickHandler('reddit')} title={title} className='share__button--reddit'>
        <RedditIcon size={32} round className={className} />
      </RedditShareButton>
            )
          : null,
        telegram
          ? (
      <TelegramShareButton key='socialTelegram' url={url} beforeOnClick={() => clickHandler('telegram')} title={title} className='share__button--telegram'>
        <TelegramIcon size={32} round className={className} />
      </TelegramShareButton>
            )
          : null,
        tumblr
          ? (
      <TumblrShareButton key='socialTumblr' url={url} beforeOnClick={() => clickHandler('tumblr')} title={title} caption={description} className='share__button--tumblr'>
        <TumblrIcon size={32} round className={className} />
      </TumblrShareButton>
            )
          : null,
        twitter
          ? (
      <TwitterShareButton key='socialTwitter' url={url} beforeOnClick={() => clickHandler('twitter')} title={title} className='share__button--twitter'>
        <XIcon size={32} round className={className} />
      </TwitterShareButton>
            )
          : null,
        viber
          ? (
      <ViberShareButton key='socialViber' url={url} beforeOnClick={() => clickHandler('viber')} title={title} className='share__button--viber'>
        <ViberIcon size={32} round className={className} />
      </ViberShareButton>
            )
          : null,
        vk
          ? (
      <VKShareButton key='socialVK' url={url} beforeOnClick={() => clickHandler('vk')} title={title} image={imageUrl} className='share__button--vk'>
        <VKIcon size={32} round className={className} />
      </VKShareButton>
            )
          : null,
        weibo
          ? (
      <WeiboShareButton key='socialWeibo' url={url} beforeOnClick={() => clickHandler('weibo')} title={title} image={imageUrl} className='share__button--veibo'>
        <WeiboIcon size={32} round className={className} />
      </WeiboShareButton>
            )
          : null,
        whatsapp
          ? (
      <WhatsappShareButton key='socialWhatsapp' url={url} beforeOnClick={() => clickHandler('whatsapp')} title={title} className='share__button--whatsapp'>
        <WhatsappIcon size={32} round className={className} />
      </WhatsappShareButton>
            )
          : null,
        workplace
          ? (
      <WorkplaceShareButton key='socialWorkplace' url={url} beforeOnClick={() => clickHandler('workplace')} quote={title} className='share__button--workplace'>
        <WorkplaceIcon size={32} round className={className} />
      </WorkplaceShareButton>
            )
          : null,
        messenger && facebookAppId
          ? (
      <FacebookMessengerShareButton key='socialMessenger' appId={facebookAppId} url={url} beforeOnClick={() => clickHandler('messenger')} className='share__button--messenger'>
        <FacebookMessengerIcon size={32} round className={className} />
      </FacebookMessengerShareButton>
            )
          : null
      ])
    : null
}

SocialLinks.propTypes = {
  email: PropTypes.bool.isRequired,
  facebook: PropTypes.bool.isRequired,
  instapaper: PropTypes.bool.isRequired,
  line: PropTypes.bool.isRequired,
  linkedin: PropTypes.bool.isRequired,
  livejournal: PropTypes.bool.isRequired,
  mailru: PropTypes.bool.isRequired,
  messenger: PropTypes.bool.isRequired,
  ok: PropTypes.bool.isRequired,
  pinterest: PropTypes.bool.isRequired,
  pocket: PropTypes.bool.isRequired,
  reddit: PropTypes.bool.isRequired,
  telegram: PropTypes.bool.isRequired,
  tumblr: PropTypes.bool.isRequired,
  twitter: PropTypes.bool.isRequired,
  viber: PropTypes.bool.isRequired,
  vk: PropTypes.bool.isRequired,
  weibo: PropTypes.bool.isRequired,
  whatsapp: PropTypes.bool.isRequired,
  workplace: PropTypes.bool.isRequired,
  facebookAppId: PropTypes.string,
  url: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  className: PropTypes.string,
  description: PropTypes.string
}

SocialLinks.defaultProps = {
  className: null,
  description: null,
  facebookAppId: null,
  imageUrl: null,
  onClick: () => {},
  title: null
}

export default memo(SocialLinks)
